export const PANES_INDICES = {
  'SCANNING_LIST': 0,
  'PENDING_LIST': 1,
  'REVIEWED_LIST': 2,
};

export const panes = [
  {'menuItem': 'Escaneo'},
  {'menuItem': 'Pendientes'},
  {'menuItem': 'Revisado'},
];
